import DeclineOrganizationTransferModal from './DeclineOrganizationTransferModal';

export default DeclineOrganizationTransferModal;
